const s = "qr_gcKNS", t = {
  qr: s
};
export {
  t as default,
  s as qr
};
//# sourceMappingURL=qrCode.module.scss.js.map
